import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';
import { Sun, Moon, Globe, LogOut, User } from 'lucide-react';
import './Header.scss';

const Header = () => {
    const { isDark, toggleTheme } = useTheme();
    const { language, changeLanguage, t } = useLanguage();
    const { user, logout } = useAuth();

    const handleLanguageToggle = () => {
        changeLanguage(language === 'tr' ? 'en' : 'tr');
    };

    return (
        <header className="admin-header">
            <div className="header-left">
                <h1>{t('dashboard')}</h1>
            </div>

            <div className="header-right">
                <div className="header-actions">
                    <button
                        className="theme-toggle"
                        onClick={toggleTheme}
                        title={isDark ? t('lightMode') : t('darkMode')}
                    >
                        {isDark ? <Sun size={20} /> : <Moon size={20} />}
                    </button>

                    <button
                        className="language-toggle"
                        onClick={handleLanguageToggle}
                        title={language === 'tr' ? 'Switch to English' : 'Türkçe\'ye Geç'}
                    >
                        <Globe size={20} />
                        <span>{language === 'tr' ? 'EN' : 'TR'}</span>
                    </button>

                    <div className="user-info">
                        <User size={16} />
                        <span>{user?.name}</span>
                    </div>

                    <button
                        className="logout-button"
                        onClick={logout}
                        title={t('logout')}
                    >
                        <LogOut size={20} />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;